import { styled } from '@mui/material';

const ButtonContent = styled('div')({
  fontSize: 'inherit',
  fontFamily: 'inherit',
  color: 'inherit',
  fontWeight: 'inherit',
  lineHeight: 'inherit',
  borderRadius: 'inherit',
  display: 'flex',
  alignItems: 'center',
});

export default ButtonContent;
